import React from 'react';
import { Section, AboutTitle, AboutText, BoldAboutText, WaveThemeImage, GhostCharacter2Image, PinkCharacter2Image, LettuceCharacterImage, StarBackground1Image, PinkCharacterImage, SmallStarImage, GhostCharacterImage, LettuceCharacter2Image, StarsBackgroundImage } from './styles';
import smallStar from '../../assets/About/smallStar.svg'; 
import waveTheme from '../../assets/About/waveTheme.png';
import ghostCharacter from '../../assets/About/ghostCharacter.png';
import ghostCharacter2 from '../../assets/About/ghostCharacter2.png';
import lettuceCharacter from '../../assets/About/lettuceCharacter.png';
import lettuceCharacter2 from '../../assets/About/lettuceCharacter2.png';
import pinkCharacter from '../../assets/About/pinkCharacter.png';
import pinkCharacter2 from '../../assets/About/pinkCharacter2.png';
import starBackGround1 from '../../assets/About/starBackGround1.png';
import starsBackground from '../../assets/About/starsBackground.png';

const About: React.FC = () => {
  return (
    <Section id="about">
        <AboutTitle>How Far We've Come, <br/> How Far We'll Go</AboutTitle>
        <AboutText>
          For our 10th anniversary, we want to reflect on our journey and bring that reflection to you. Whether you are a seasoned hacker or a curious newcomer, together, let's rediscover our north stars and rekindle passions, old and new.
        </AboutText>
        <BoldAboutText>What forgotten dreams will you awaken and transform?</BoldAboutText>
        <WaveThemeImage src={waveTheme} alt="Wave Theme" />
        <GhostCharacter2Image src={ghostCharacter2} alt="Ghost Character HeadPhones" />
        <PinkCharacter2Image src={pinkCharacter2} alt="Pink Character2" />
        <LettuceCharacterImage src={lettuceCharacter} alt="Lettuce Character" />
        <StarBackground1Image src={starBackGround1} alt="Star BackGround1" />
        <PinkCharacterImage src={pinkCharacter} alt="Pink Character" />
        <SmallStarImage src={smallStar} alt="Small Star" />
        <GhostCharacterImage src={ghostCharacter} alt="Ghost Character" />
        <LettuceCharacter2Image src={lettuceCharacter2} alt="Lettuce Character2" />
        <StarsBackgroundImage src={starsBackground} alt="Stars Background" />
    </Section>
  );
}

export default About;